import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participant-orientations-item',
  templateUrl: './participant-orientations-item.component.html',
  styleUrls: ['./participant-orientations-item.component.scss']
})
export class ParticipantOrientationsItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
